"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VM_OPCODE_MASK = exports.VM_OPCODE_COUNT = void 0;
exports.VM_OPCODE_COUNT = 512;
exports.VM_OPCODE_MASK = 511;
